
import { Model } from '../../model/model';
import { Baseline } from '@wizeoo/akm-message-lib';
import { WizCommand, WizRoot } from '@wizeoo/akm-component-lib';
import { ConnectVO } from '../../vo/core/connect.vo';
import { ExternalAPI } from '../../model/external-api';
import { FreeDataVO } from '../../vo/core/freedata.vo';
import { FreedataValueVO } from '../../vo/core/freedatavalue.vo';
import { EnvironnementManager } from '../../model/environnement.manager';
/**
 * Appels fonctions connect
 * Author LMA
 */
export class ConnectCmd extends WizCommand<any> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  /**
   * Construit le wrapper avec les informations de base
   * @returns Wrapper
   */
  public wrapper(): any {
    const wrapper: any = {};
    wrapper.domain = this.model.domainCode;
    wrapper.bu = this.model.businessUnitCode;
    wrapper.visionCode = this.model.visionCode;
    wrapper.login = this.model.connectedUser.mail;
    wrapper.locale = this.model.currentLocaleCode;
    wrapper.uuid = WizRoot.getInstance().uuid;
    return wrapper;
  }

  private vOneOrTwo(cnx: ConnectVO): string {
    let version: number = cnx?.parameters?.version || 1; // version connect
    
    if(version === 3) { // le 2 est déjà utilisé pour les nextGen
      return ExternalAPI.CALL_CONNECT_V2;
    }
    return ExternalAPI.CALL_CONNECT;
  }

  /** 
   * Appel connect d'une fonction libre (ni FDV ni Baseline)
   * @param connectAction 
   * @param wrapper avec paramètres
   * @returns 
   */
  public call(connectAction: ConnectVO, wrapper: any, callback: Function = null): ConnectCmd {

    this.cnx = connectAction;
    // console.log('cnx wrapper call', wrapper);



    this.configureRemote(EnvironnementManager.envConfig.connectUrl + '/' + this.vOneOrTwo(this.cnx), wrapper, callback);
    return this;
  }



  private freedata: FreeDataVO = null;
  private freedataValue: FreedataValueVO = null;
  private baselines: Baseline[]= null;
  public cnx: ConnectVO = null;

  /** 
   * Appel connect d'une fonction libre (ni FDV ni Baseline)
   * @param connectAction 
   * @returns 
   */
  public callFromFree(connectAction: ConnectVO, callback: Function = null): ConnectCmd {

    this.cnx = connectAction;
    const wrapper = this.wrapper();

    wrapper.code = connectAction.processCode;
    wrapper.mode = connectAction.processMode;
    wrapper.connectFunctionCode = connectAction.code;
    wrapper.body = {
      "method": "get",
      "entity": {
        "domain": this.model.domainCode,
        "businessUnitCode": this.model.businessUnitCode
      },
    };

    // console.log('cnx wrapper', wrapper);
    this.configureRemote(EnvironnementManager.envConfig.connectUrl + '/' + this.vOneOrTwo(this.cnx), wrapper, callback);
    return this;
  }


  /** 
   * Appel connect depuis un grid / formulaire FreedataValue
   * @param connectAction 
   * @param FreeDataVO 
   * @param FreedataValueVO 
   * @returns 
   */
  public callFromFreedata(connectAction: ConnectVO, fd: FreeDataVO, fdv: FreedataValueVO, callback: Function = null): ConnectCmd {

    this.cnx = connectAction;
    this.freedata = fd;
    this.freedataValue = fdv;

    const wrapper = this.wrapper();

    wrapper.code = connectAction.processCode;
    wrapper.mode = connectAction.processMode;
    wrapper.connectFunctionCode = connectAction.code;
    wrapper.body = {
      "method": "get",
      "entity": {
        "domain": this.model.domainCode,
        "businessUnitCode": this.model.businessUnitCode,
        "freeDataCode": this.freedata?.code,
        "code": this.freedataValue?.code
      },
      "scenario": { "manageValues": "true" }
    };

    // console.log('cnx wrapper', wrapper);
    this.configureRemote(EnvironnementManager.envConfig.connectUrl + '/' + this.vOneOrTwo(this.cnx), wrapper, callback);
    return this;
  }

  /** 
   * Appel connect depuis un grid / formulaire FreedataValue
   * @param connectAction 
   * @param FreeDataVO 
   * @param FreedataValueVO 
   * @returns 
   */
  public callFromBaseline(connectAction: ConnectVO, baselines: Baseline[], callback: Function = null): ConnectCmd {

    this.cnx = connectAction;
    this.baselines = baselines;

    const wrapper = this.wrapper();

    wrapper.code = connectAction.processCode;
    wrapper.mode = connectAction.processMode;
    wrapper.connectFunctionCode = connectAction.code;
    // wrapper.body =  {"method": "get", 
    //                   "entity": {
    //                     "domain":model.domainCode,
    //                     "businessUnitCode":model.businessUnitCode,
    //                   }, 
    //                   "scenario": { "manageValues": "true" }
    //                 };

    // console.log('cnx wrapper', wrapper);
    // this.configureRemote(environment.connectUrl + '/' + ExternalAPI.CALL_CONNECT, wrapper, callback);

    console.log('TODO TODO');
    return this;
  }


  /**
   * retour de service
   * gestion de retour selon la méthode d'appelle
   */
  public wizResult(): void {
    super.wizResult();
  }

  /**
   * Surcharge du wizFault pour notification des erreurs "technique".
   * Les erreurs métier sont dans wizResult
   */
  public wizFault() {
    super.wizFault();
  }
}
